import { memo } from 'react'

import { ChatPanel } from 'features/chat/components/chatPanel/chatPanel'
import { useGroupChatChatPanel } from './useGroupChatChatPanel'

export const GroupChatChatPanel = memo(() => {
  useGroupChatChatPanel()

  return (
    <div className="flex flex-col grow min-h-0 h-full w-full">
      <ChatPanel />
    </div>
  )
})
